import { render, staticRenderFns } from "./PhysicianImport.vue?vue&type=template&id=24773834&scoped=true"
import script from "./PhysicianImport.vue?vue&type=script&lang=js"
export * from "./PhysicianImport.vue?vue&type=script&lang=js"
import style0 from "./PhysicianImport.vue?vue&type=style&index=0&id=24773834&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24773834",
  null
  
)

export default component.exports